/* Chilli Bomba - compare-at ("Save $X") display.

   Why this is a script and not part of the Liquid: sections/main-product.liquid
   prints the strikethrough only for the variant Liquid picked at page load, and
   its own sync() updates [data-cb-price] but never touches the compare-at
   element. The buybox also forces the default selection to the Single 8oz
   variant. So a compare-at set on any other variant - which is every "Double"
   bag - was stored in Shopify and never shown to the customer.

   Runs over every buybox on the page, not just the product page's. The home
   page's "best seller" block (sections/cb-featured-product.liquid) is a second,
   separately written buybox; it was showing no saving at all, and its own inline
   script listened for a [data-cb-variant] <select> that does not exist in its
   markup, so its price never updated when you picked a size either. Both are
   handled here now.

   A scope is either a .cb-buybox (product page) or anything carrying
   data-cb-handle (the featured block). The handle tells us which product's JSON
   to read; the product page falls back to the URL.

   The saving is computed from the swatch's own data-cents, never from the price
   in that JSON. Product page HTML is CDN-cached and the JSON is not, so for a
   minute after a price change the two disagree - reading the DOM means the badge
   always matches the number the customer can actually see.
*/
(function () {
  function money(c) {
    var d = c / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  var urlMatch = location.pathname.match(/\/products\/([^\/?#]+)/);
  var urlHandle = urlMatch ? urlMatch[1] : null;

  var scopes = [].slice.call(document.querySelectorAll('.cb-buybox, [data-cb-handle]'));

  scopes.forEach(function (scope) {
    var radios = [].slice.call(scope.querySelectorAll('[data-cb-size]'));
    if (!radios.length) return;

    var handle = scope.getAttribute('data-cb-handle') || urlHandle;
    if (!handle) return;

    var panel = scope.closest('.f-product-desc') || scope;
    var CMP = {};

    function current() {
      for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i]; }
      return null;
    }

    function saving(r) {
      if (!r) return 0;
      var c = CMP[r.value], p = parseInt(r.getAttribute('data-cents'), 10);
      if (!c || !p || c <= p) return 0;
      return c - p;
    }

    function paintPrice() {
      var r = current();
      if (!r) return;
      var money_attr = r.getAttribute('data-money');
      if (!money_attr) return;
      var els = panel.querySelectorAll('[data-cb-price]');
      for (var i = 0; i < els.length; i++) { els[i].textContent = money_attr; }
    }

    function paintHeader() {
      var priceEl = panel.querySelector('[data-cb-price]');
      if (!priceEl) return;
      var host = priceEl.parentNode;
      var r = current(), s = saving(r);
      var el = host.querySelector('[data-cb-compare]');
      if (s > 0) {
        if (!el) {
          el = document.createElement('p');
          el.className = 'fp-price font-p2 sale';
          el.setAttribute('data-cb-compare', '');
          host.insertBefore(el, priceEl);
        }
        el.innerHTML = '<s>' + money(CMP[r.value]) + ' USD</s>';
        el.hidden = false;
      } else if (el) {
        el.hidden = true;
      }
    }

    function paintChip() {
      var row = panel.querySelector('.cb-buybox__row');
      if (!row) return;
      var r = current(), s = saving(r);
      var chip = row.querySelector('[data-cb-save]');
      if (s > 0) {
        if (!chip) {
          chip = document.createElement('span');
          chip.className = 'cb-save';
          chip.setAttribute('data-cb-save', '');
          row.appendChild(chip);
        }
        chip.textContent = 'Save ' + money(s);
        chip.hidden = false;
      } else if (chip) {
        chip.hidden = true;
      }
    }

    function paintSwatches() {
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i], inner = r.nextElementSibling;
        if (!inner) continue;
        var s = saving(r);
        if (s <= 0 || r.disabled) continue;
        var flag = inner.querySelector('.cb-size__flag');
        if (!flag) {
          flag = document.createElement('span');
          flag.className = 'cb-size__flag';
          inner.insertBefore(flag, inner.firstChild);
        }
        flag.className = 'cb-size__flag cb-size__flag--save';
        flag.textContent = 'Save ' + money(s);
      }
    }

    function paint() { paintPrice(); paintHeader(); paintChip(); paintSwatches(); }

    for (var i = 0; i < radios.length; i++) { radios[i].addEventListener('change', paint); }

    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (d) {
        if (!d || !d.variants) return;
        for (var i = 0; i < d.variants.length; i++) {
          var v = d.variants[i];
          if (v.compare_at_price) { CMP[String(v.id)] = v.compare_at_price; }
        }
        paint();
      })
      .catch(function () {});
  });
})();